import { Close as CloseIcon, Star } from '@mui/icons-material';
import {
  Button,
  Checkbox,
  Chip,
  FormControl,
  FormHelperText,
  InputLabel,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Modal,
  Select,
  TextField
} from '@mui/material';
import { styled as muiStyled } from '@mui/material/styles';
import * as Sentry from "@sentry/react";
import { Col, Row } from "antd";
import Loading from "components/Loading";
import Tag from "components/Tag";
import { useAlert } from 'components/UI/alertSakeBar/alertProvider';
import { find, get, map } from "lodash";
import React, { useEffect, useMemo, useState } from "react";
import { useCurrentClass } from "store/classes/selectors";
import { useUsersByClass } from "store/userClasses/selectors";
import { useCurrentUser } from "store/users/selectors";
import styled from "styled-components";
import COLOR from "utils/constants/color";
import { getAvailableStudents } from '../helper';

//  -- Components ---------------------




//  -- Constants ----------------------








const StyledFormControl = muiStyled(FormControl)(({ theme }) => ({
  margin: '2px',
  minWidth: 120,
  maxWidth: 300,
}));

const ChipsContainer = muiStyled('div')(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
}));

const StyledChip = muiStyled(Chip)(({ theme }) => ({
  margin: 2,
}));

const MultiMenu = {
  PaperProps: {
    style: {
      maxHeight: 48 * 4.5 + 8,
      width: 250,
    },
  },
};

const ModalContent = styled.div`
  align-items: center;
  background-color: ${COLOR.white};
  border-radius: 3px;
  display: inline-flex;
  flex-direction: column;
  left: 50%;
  max-width: 550px;
  padding: 16px;
  position: absolute;
  text-align: center;
  top: 50%;
  transform: translate(-50%, -50%);
  overflow: scroll;
  max-height: 90vh;
  min-width: 450px;
`;

const CloseButton = styled.div`
  // background-color: ${COLOR.PinkExam};
  background-color: rgb(204, 80, 71);
  border: none;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  position: absolute;
  top: 10px;
  right: 10px;
  color: white;
  z-index: 1;
`;

const CreateStudentGroup = ({
  open,
  onClose,
  handleSubmit,
  previewData,
  data,
}) => {
  const showAlert = useAlert();
  const currentUser = useCurrentUser();
  const currentClass = useCurrentClass();
  const usersByClass = useUsersByClass();
  const [retake, setRetake] = useState("");
  const [noOfAnswer, setNoOfAnswer] = useState("");
  const [selectedStudent, setSelectedStudent] = useState([]);
  const [groupName, setGroupName] = useState("");
  const [submitLoader, setSubmitLoader] = useState(false);
  const listStudents =
    get(usersByClass, get(currentClass, "id"), []).filter(
      (x) => x.role === "student"
    ) || [];
  const availableStudents = useMemo(() => getAvailableStudents(previewData, data, listStudents) || [], [previewData, data, listStudents]);
 

  useEffect(() => {
    if (previewData) {
      setSelectedStudent(previewData?.config || []);
      setRetake(previewData?.total_attempts || "");
      setNoOfAnswer(previewData?.number_of_answer || "");
      setGroupName(previewData?.group_name || "");
    }

    return () => {
      setSelectedStudent([]);
      setRetake("");
      setNoOfAnswer("");
      setGroupName("");
    };
  }, [previewData]);

  const handleDone = async () => {
    try {
      if (selectedStudent?.length === 0) {
        showAlert("No student Available", "error");
        return;
      }
      const checkValidation =
        groupName?.length === 0 ||
        retake?.length === 0 ||
        noOfAnswer?.length === 0;
      if (checkValidation) {
        showAlert("Please fill all required field", "error");
        return;
      }
      setSubmitLoader(true);
      let data = {
        group_name: groupName,
        config: selectedStudent,
        class_id: get(currentClass, "id"),
        number_of_answer: noOfAnswer,
        total_attempts: retake,
        created_by: currentUser?.id,
      };
      if (previewData) {
        data.id = previewData?.id;
      }
      await handleSubmit(data);
      setSubmitLoader(false);
    } catch (error) {
      Sentry.captureException(error);
    }
  };

  // Handle student selection change
  const handleStudentChange = (event) => {
    setSelectedStudent(event.target.value);
  };

  // Check if a student is selected
  const isStudentSelected = (studentId) => {
    return selectedStudent.includes(studentId);
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      className="modal-for-rubric bg-transparent"
    >
      <ModalContent className='createGrpMdl' orientation={window.screen.orientation?.type}>
        <CloseButton
          onClick={() => {
            setSelectedStudent([]);
            setRetake("");
            setNoOfAnswer("");
            setGroupName("");
            onClose();
          }}
        >
          <CloseIcon />
        </CloseButton>

        <div className='createGrpField' onClick={(e) => e?.preventDefault()}>
          <TextField
            label="Group Name*"
            value={groupName}
            onChange={(e) => setGroupName(e.target.value)}
          />
        </div>
        <Row
          gutter={[24, 24]}
          className="selectStudents createGrpSelect"
          style={{ width: "100%", paddingLeft: 5 }}
        >
          <StyledFormControl style={{ marginTop: "15px" }}>
            <InputLabel id="bookList-label">Select students*</InputLabel>
            <Select
              labelId="mutiple-select-label"
              multiple
              value={selectedStudent}
              onChange={handleStudentChange}
              displayEmpty
              placeholder="Select"
              disabled={availableStudents.length === 0 && selectedStudent.length === 0}
              style={{
                backgroundColor:
                  availableStudents.length === 0 && selectedStudent.length === 0 ? "#f5f5f5" : "",
              }}
              renderValue={(selected) => (
                <ChipsContainer>
                  {selected.map((value) => {
                    const student = find(listStudents, (k) => k.id === value);
                    const label = student
                      ? `${student.lastName || ""} ${student.firstName || ""}`
                      : "Unknown Student";
                    return (
                      <StyledChip
                        key={value}
                        label={label}
                      />
                    );
                  })}
                </ChipsContainer>
              )}
              MenuProps={MultiMenu}
            >
              {map(availableStudents, (option) => (
                <MenuItem key={option.id} value={option.id}>
                  <ListItemIcon>
                    <Checkbox checked={isStudentSelected(option.id)} />
                  </ListItemIcon>
                  <ListItemText
                    primary={`${option.lastName || ""} ${
                      option.firstName || ""
                    }`}
                  />
                </MenuItem>
              ))}
            </Select>
          </StyledFormControl>
        </Row>

        <Col className="createGrpSelect mt-10px" span={24}>
          <FormControl variant="outlined">
            <InputLabel style={{ backgroundColor: "#fff" }}>
              Select number of answers*
            </InputLabel>
            <Select
              id="levelExercise"
              value={noOfAnswer || ""}
              onChange={(e) => setNoOfAnswer(e.target.value)}
              label="Select number of answers"
              displayEmpty
            >
              {map(levels, (level) => (
                <MenuItem key={level.id} value={level.value}>
                  {level.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Col>
        <Container>
          <Row gutter={[16, 24]}>
            <Col span={16} className='starNotes'>
              <Tag height={20}>
                <Star
                  style={{
                    height: "12px",
                    margin: "-1px 4px 0px 0px",
                    width: "12px",
                  }}
                />{" "}
                NOTE
              </Tag>
              <Note>
                This is the differentiation number of total attempts the
                differentiation student will have for this quiz.
              </Note>
            </Col>
            <Col span={8}>
              <TextField
                id="retakesDif"
                onChange={(e) => {
                  if (e.target.value < 0 || e.target.value > 100) {
                    return;
                  }
                  setRetake(e.target.value);
                }}
                variant="outlined"
                value={parseInt(retake, 10) || 0}
                type="number"
                InputProps={{
                  inputProps: {
                    min: 0,
                  },
                }}
              />
            </Col>
          </Row>
          <Col
            span={12}
            style={{ display: "flex", justifyContent: "flex-start" }}
          >
            {availableStudents.length === 0 && selectedStudent.length === 0 ? (
              <FormHelperText error>
                {`There are no students remaining to be added to this group.`}
              </FormHelperText>
            ) : null}
          </Col>
          <div className="flex justify-end items-center mt-10px w-full">
            <Button
              disabled={submitLoader}
              color="primary"
              variant="contained"
              onClick={handleDone}
            >
              {submitLoader && <Loading white={true} size={16} />}
              {previewData ? "Update" : "Done"}
            </Button>
          </div>
        </Container>
      </ModalContent>
    </Modal>
  );
};

export default CreateStudentGroup;

const levels = [
  {
    id: "1",
    value: "easy",
    label: "2",
  },
  {
    id: "2",
    value: "medium",
    label: "3",
  },
  {
    id: "3",
    value: "hard",
    label: "4",
  },
];

const Container = styled.div`
  border-top: 1px solid ${COLOR.black700};
  margin-top: 24px;
  padding-top: 40px;
  width: 100%;
`;
const Note = styled.span`
  color: ${COLOR.black400};
  display: block;
  font-size: 13px;
  font-weight: 400;
  line-height: 20px;
  margin-bottom: 16px;
`;
const CrossSection = styled.span`
  border: 1px solid;
  padding: 10px;
  margin-top: 30px;
  position: relative;
`;
const SectionTitle = styled.div`
  font-size: 14px;
  color: #ffffff;
  background: ${COLOR.tabActive};
  padding: 4px 8px;
  border-radius: 6px !important;
  cursor: pointer;
  position: absolute;
  top: -15px;
  padding-left: 24px;
  padding-right: 24px;
  font-weight: bold;
  letter-spacing: 0.5px;
`;

const RubricSubContainerDiv = styled.div`
  padding-inline: 20px;
  padding-top: 4px;
  padding-bottom: 4px;
`;

const RubricContainerDiv = styled.div`
  justify-content: space-between;
  border: 1px solid darkgrey;

  border-radius: 12px;
  align-items: center;

  boxShadow: 0px 0px 10px rgba(0,0,0,0.2);
  transition: all 0.3s ease-in-out;
  &:hover {
  box-shadow: ${(p) => (p.loader ? "" : "0px 0px 10px rgba(0,0,0,0.3)")};
  // transform: scale(1.02);
  },
`;